import * as React from 'react';
import { observer, inject } from "mobx-react";
import { Button, TextField, Dialog, DialogContent, DialogActions, DialogTitle, DialogContentText } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import EditIcon from '@material-ui/icons/Edit';

// =====================================
// CONSTS
import { Messages } from '../../const/Messages';

// =====================================
// STORES
import { IOrdersStore } from '../../store/OrdersStore';

// =====================================
// COMPONENTS
import { Header } from '../Layout/Header';

@inject((allStores: any) => ({
    ordersStore: allStores.store.ordersStore as IOrdersStore
}))

@observer
export default class NewOrderArticlesPriceChange extends React.Component<{ ordersStore?: IOrdersStore; customerId?: any }, {}> {
    render() {
        return (
            <div className="new-order">
                <Header
                    title={'Promena cene artikala'}
                    isBackButtonVisible={true}
                    samePageAction={this.props.ordersStore.handleShowModal} />

                <div className="container">
                    {this.props.ordersStore.productsForOrder.map((product, i) => {
                        return <div className="order-container" key={i}>
                            <div className="product">
                                <div className="product-row">{product.code}</div>
                                <div className="product-row">{product.name}</div>
                                <div>Osnovna cena: {product.acquisitionPrice.toLocaleString("sr", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} RSD</div>

                                <div>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className="add-btn"
                                        onClick={() => { this.props.ordersStore.showInputForPriceChange(product) }}
                                        startIcon={<EditIcon />}
                                    >Promeni cenu
                                    </Button>
                                    {(this.props.ordersStore.selectedRowId === product.id || product.customSalesPrice !== "") ?
                                        <div>
                                            <TextField
                                                type="number"
                                                label="Posebna cena"
                                                className="product-form-input"
                                                value={product.customSalesPrice}
                                                onChange={(event) => { this.props.ordersStore.handleChangeAcquisitionPrice(event, product.id) }} />
                                        </div> : null}
                                </div>
                            </div>
                        </div>
                    })}

                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className="save-btn"
                        onClick={() => { this.props.ordersStore.editFavouriteArticles(this.props.customerId) }}
                        startIcon={<SaveIcon />}
                    >Snimi
                    </Button>
                </div>

                <Dialog
                    open={this.props.ordersStore.isModalVisible}
                    onClose={this.props.ordersStore.handleCloseModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle>{"Otkazivanje izmena"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {Messages.CANCEL_PRICE_CHANGE}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.props.ordersStore.handleCloseModal} color="primary">
                            NE
                        </Button>
                        <Button onClick={this.props.ordersStore.goBackToOrderDetails} color="primary" autoFocus>
                            DA
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}